import React from 'react';
import {
    Form, ModalBody, ModalFooter, Button, FormGroup, Label, Col, Row, Container, FormText
} from 'reactstrap';
import SelectListComponent from "../utils/selectList";
import DateSelector from '../utils/dateSelector';
import {appConstants} from "../../_constants";
import {commonService} from "../../_services";
import ManifestDeleteSuccess from "./successful-manifest-delete";
import ManifestDeleteInfo from "./info-manifest-delete";
import ManifestDeleteFail from "./failed-manifest-delete";
import moment from "moment/moment";

class ManifestDelete extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            airlines: [],
            FlightNumbers: [],
            modal: false,
            modalClass: '',
            //page error
            contentError: false,  //Errors that affect content on the page
            componentError: false,  //Errors generated within the component
            componentErrorMessages: [],  //Errors generated within the component form
            failedManifestDelete: false, //Error state mutable via Redux
            infoManifestDelete: false, //Error state mutable via Redux
            successfulManifestDelete: false, //Success message mutable via Redux
            manifestDeleteResponse: '', //Success message mutable via Redux
            manifestDeleteCount: 0, //Success message mutable via Redux

            //    Notification
            notification: {
                // title: 'Default Title',
                message: 'Default Message',
                level: 'success',
                position: 'tr',
                dismissible: true
            },
            //Delete Manifest form
            StartDate: new Date(),
            EndDate: new Date(),
            AirlineId: '',
            ReferenceId: '',
            FlightNumber: '',
            IsLocal: false,
        };

        this._notificationSystem = null;
        this._lastNotificationAdded = null;
    }
    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
    }

    validateInput = () => {
        let _errs_ = [];
        let formValid = true;
        const { StartDate, EndDate, AirlineId, FlightNumber } = this.state;
        if( StartDate=== ''){
            _errs_['StartDate'] = 'Please select flight start date';
            formValid = false;
        }
        if(EndDate === ''){
            _errs_['EndDate'] = 'Please select flight end date';
            formValid = false;
        }
        if(AirlineId === '') {
            _errs_['AirlineId'] = 'Please select airline';
            formValid = false;
        }
        if(FlightNumber === '') {
            _errs_['FlightNumber'] = 'Please enter flight number';
            formValid = false;
        }
        this.setState({componentErrorMessages: _errs_});
        return formValid;
    };

    handleSubmit  = (event) => {
        event.preventDefault();
        this.setState({isRequesting: true});
        this.resetError();
        if(this.validateInput()){
            this.processSubmit();
        }
    };

    handleAirlineChange = (payload) => {
         if(payload === null && this.state.AirlineId !== ''){
            this.setState({ AirlineId : '', FlightNumbers: []});
        }else if (!(payload === null && this.state.AirlineId === '')) {
            let currState = this.state;
            let errorMessages = this.state.componentErrorMessages;
            errorMessages['AirlineId'] = false;
            currState['AirlineId'] = (payload) ? payload['Id'] : '';
            currState['IsLocal'] = payload.IsLocal;
            this.setState(currState);
            this.fetchAirlineFlightNumbers(payload.Id);
        }
    };
    handleFlightNumberChange = (payload) => {
        if (payload === null && this.state.FlightNumber !== '') {
            this.setState({ FlightNumber : ''});
        }else if (!(payload === null && this.state.FlightNumber === '')) {
            let currState = this.state;
            let errorMessages = this.state.componentErrorMessages;
            errorMessages['FlightNumber'] = false;
            currState['FlightNumber'] = (payload) ? payload['FlightNumber'] : '';
            this.setState(currState);
        }
    };

    handleChange = (event, attribute) => {
        let currState = this.state;
        currState[attribute] = event.target.value;
        let errorMessages = this.state.componentErrorMessages;
        errorMessages[attribute] = false;
        this.setState(currState);
        this.setState({componentErrorMessages: errorMessages});
    };

    renderPageResponse() {
        if(this.state.error){
            return (<div className="alert alert-danger">{this.state.error}</div>);
        }
        else if(this.state.componentError){
            return (<div className="alert alert-danger">{this.state.componentError}</div>);
        }
        else if(this.state.success){
            return (<div className="alert alert-success">{this.state.success}</div>);
        }
    }

    processSubmit = () => {
        const { StartDate, EndDate, AirlineId, FlightNumber } = this.state;

        this.setState({requesting: true});
        let payload = {
            "AirlineId": AirlineId,
            "FlightNumber": FlightNumber,
            "StartDate": moment(StartDate).format('YYYY-MM-DD') + "T00:00:00",
            "EndDate": moment(EndDate).format('YYYY-MM-DD') + "T23:59:59",
        };

        commonService.bulkDeleteManifest(payload)
            .then((res) => {
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    const manifestCount = res.response.data.ManifestsCount;
                    if(manifestCount === 0){
                        this.setState({ ReferenceId: '', manifestDeleteCount: manifestCount, failedManifestDelete : true, infoManifestDelete : false, successfulManifestDelete: false, manifestDeleteResponse : 'No manifest found.'})
                    }else{
                        const manifestText = (manifestCount > 1) ? ' manifests' : ' manifest';
                        this.setState({ ReferenceId: res.response.data.ReferenceId, manifestDeleteCount: manifestCount, failedManifestDelete : false, infoManifestDelete : true, successfulManifestDelete: false, manifestDeleteResponse : manifestCount + manifestText +' deleted successfully.'});
                    }
                    this.setState({ requesting: false });
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    this.setState({});
                    this.setState({ ReferenceId: '', requesting: false, failedManifestDelete : true, infoManifestDelete : false, successfulManifestDelete: false, manifestDeleteResponse: res.response});
                }
            });
    }
    processDeleteManifest = (event) => {
        event.preventDefault();
        const { ReferenceId } = this.state;

        this.setState({requesting: true});
        let payload = {
            "ReferenceId": ReferenceId,
        };

        commonService.deleteManifestByReference(payload)
            .then((res) => {
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    this.setState({ requesting: false, failedManifestDelete : false, infoManifestDelete : false, successfulManifestDelete: true});
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    this.setState({ requesting: false, failedManifestDelete : true, infoManifestDelete : false, successfulManifestDelete: false, manifestDeleteResponse: res.response});
                }
            });
    }
    resetForm() {
        this.setState({componentError: false, componentErrorMessages: [], failedManifestDelete : false, successfulManifestDelete: false, AirlineId: '', FlightNumber: '', StartDate: '', EndDate: '', IsLocal: false });
    }
    resetError() {
        this.setState({componentError: false, componentErrorMessages: [], failedManifestDelete : false, successfulManifestDelete: false});
    }
    notify = (message, level) => {
        let notification = this.state.notification;
        notification['message'] = message;
        notification['level'] = level;
        notification.onRemove = this.onRemove;
        this._lastNotificationAdded = this._notificationSystem.addNotification(notification);
    };

    fetchAirlineFlightNumbers = (airlineId) => {
        this.setState({FlightNumbers: [], requesting: true});
        commonService.getAirlinesFlightNumbers(airlineId)
            .then((res) => {
                let response = res.response;
                 if(res.status === appConstants.SUCCESS_RESPONSE) {
                    this.setState({failedManifestDelete : false, FlightNumbers: response.Results, requesting: false});
                }
                else if(res.status === appConstants.ERROR_RESPONSE){
                     this.setState({ requesting: false, failedManifestDelete : true, successfulManifestDelete: false, manifestDeleteResponse: res.response});
                }
            });
    };

    render() {
        let modalResponse = this.renderPageResponse();
        const { requesting, manifestDeleteResponse, infoManifestDelete, componentErrorMessages, failedManifestDelete, successfulManifestDelete, FlightNumbers, manifestDeleteCount } = this.state;
        const { airlines, toggleModal } = this.props;
        return (
            <div>
                <Form onSubmit={this.handleSubmit}>
                    <ModalBody>
                        <Container>
                            { modalResponse }
                            <Row>
                                <Col sm={"6"}>
                                    <FormGroup className={"mb-4 " + (this.state.componentErrorMessages.AirlineId ? 'has-danger' : '')}>
                                        <Label>Airline</Label>
                                        <SelectListComponent placeholder={'Select airline...'} data={airlines} valueKey='Id' textField='Name' selectValue={this.state.AirlineId} onValueChange={(payload) => this.handleAirlineChange(payload)} />
                                        { componentErrorMessages.AirlineId && <FormText color="danger"> {componentErrorMessages.AirlineId }</FormText> }
                                    </FormGroup>
                                </Col>
                                <Col sm={"6"}>
                                    <FormGroup className={"mb-4 " + (this.state.componentErrorMessages.FlightNumber ? 'has-danger' : '')}>
                                        <Label>Flight Number</Label>
                                        <SelectListComponent placeholder={'Select flight number...'} data={FlightNumbers} valueKey='FlightNumber' textField='FlightNumber' selectValue={this.state.FlightNumber} onValueChange={(payload) => this.handleFlightNumberChange(payload)} />
                                         { componentErrorMessages.FlightNumber && <FormText color="danger"> {componentErrorMessages.FlightNumber }</FormText> }
                                    </FormGroup>
                                </Col>
                                <Col sm={"6"}>
                                    <FormGroup className={"mb-4 " + (this.state.componentErrorMessages.StartDate ? 'has-danger' : '')}>
                                        <Label>Flight Start Date</Label>
                                        <DateSelector
                                            maxDate={new Date()}
                                            todayDate={(new Date()).toString()}
                                            name="startDate" onValueChange={StartDate => this.setState({ StartDate })} />
                                        { componentErrorMessages.StartDate && <FormText color="danger"> {componentErrorMessages.StartDate }</FormText> }
                                    </FormGroup>
                                </Col>
                                <Col sm={"6"}>
                                    <FormGroup className={"mb-4 " + (this.state.componentErrorMessages.EndDate ? 'has-danger' : '')}>
                                        <Label>Flight End Date</Label>
                                        <DateSelector
                                            maxDate={new Date()}
                                            todayDate={(new Date()).toString()}
                                            name="endDate" onValueChange={EndDate => this.setState({ EndDate })} />
                                        { componentErrorMessages.EndDate && <FormText color="danger"> {componentErrorMessages.EndDate }</FormText> }
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col sm={'12'}>
                                    { infoManifestDelete &&
                                        <div className='manifest-delete-response'>
                                            <ManifestDeleteInfo deleteManifest={this.processDeleteManifest} manifestCount={manifestDeleteCount}/>
                                        </div>
                                    }
                                    { failedManifestDelete &&
                                        <div className='manifest-delete-response'>
                                            <ManifestDeleteFail manifestDeleteResponse={manifestDeleteResponse}/>
                                        </div>
                                    }
                                    { successfulManifestDelete &&
                                        <div className='manifest-delete-response'>
                                            <ManifestDeleteSuccess manifestDeleteResponse={manifestDeleteResponse}/>
                                        </div>
                                    }
                                </Col>
                            </Row>
                        </Container>
                    </ModalBody>
                    <ModalFooter>
                        {
                            infoManifestDelete &&
                            <Button className="btn-warning" disabled={requesting} onClick={this.processDeleteManifest}> Confirm Delete </Button>
                        }
                        {
                            !infoManifestDelete &&
                            <Button className="btn-avi-primary" disabled={ requesting } > Proceed </Button>
                        }
                        <Button color="secondary" onClick={toggleModal}>Cancel</Button>
                    </ModalFooter>
                </Form>
            </div>
        )
    }
}

export default ManifestDelete;



// WEBPACK FOOTER //
// ./src/views/search/manifest-delete.js